export enum LocationProperties {
  ALL_LOCATIONS = 'ALL_LOCATIONS',
  ONE_LOCATION = 'ONE_LOCATION',
  SELECTED_LOCATIONS = 'SELECTED_LOCATIONS',
}
